'use strict';

export class DolStreamPromo {
	constructor() {
		this.API = '/api/ajax/dol/';
		if (yalwa.v.dol_stream_toaster_timer) {
			window.setTimeout(this.timeout_callback.bind(this), parseInt(yalwa.v.dol_stream_toaster_timer));
		} else {
			if (this.can_be_shown()) {
				this.get_data().then(this.show.bind(this));
			}
		}
	}
	
	timeout_callback() {
		this.get_data().then(this.show.bind(this));
	}
	
	can_be_shown() {
		return yalwa.v.dol_stream_toaster_can_be_shown;
	}
	
	get_data() {
		return jQuery.ajax({
			url: this.API,
			dataType: 'json',
			type: 'GET',
			cache: false,
			data: {
				action: 'get_live_streams_toastr'
			}
		});
	}
	
	set_ts_on_profile() {
		return jQuery.ajax({
			url: this.API,
			dataType: 'json',
			type: 'POST',
			cache: false,
			data: {
				action: 'set_live_stream_toastr_ts',
			}
		}).done(function(response) {
			if (response.success) {
				yalwa.v.live_stream_toastr_ts = response.live_stream_toastr_ts;
			}
		});
	}
	
	show(response) {
		if (
			!response.success ||
			!(response.data && response.data.length) ||
			!jQuery('.js-generic_shadow').hasClass('hidden')
		) {
			return;
		}
		const text = response.toastr_body_text;
		const cta =	response.toastr_cta_text;
		const pic =	response.toastr_profile_pic;
		let template = `
				<div class="locanto_live_stream_toastr__body js-dol_stream_toastr">
					<div class="locanto_live_stream_toastr__img">
						<img src="${pic}" width="32px" height="32px" alt="" />
					</div>
					<div class="locanto_live_stream_toastr__text">${text}</div>
					<div class="locanto_live_stream_toastr__button_container">
						<div class="locanto_live_stream_toastr__button js-live_stream_toaster">${cta}</div>
					</div>
				</div>`;
		this.track('view', response.watcher_gender_string);
		yalwa.basics.toast({
			progressBar: true,
			show_icon: 'no',
			message: template,
			type: 'success',
			timeOut: 7000, // 7 seconds delay for toastr
			extendedTimeOut: 1000,
			positionClass: "toast-top-full-width locanto_live_stream_toastr",
			onclick: this.toaster_click_handler.bind(this, response.utm_url, response.watcher_gender_string),
			onShown: function(){}
		});
		this.set_ts_on_profile();
	}
	toaster_click_handler(utm_url, watcher_gender_string) {
		this.track('click', watcher_gender_string);
		yalwa.basics.navigate(utm_url)
	}
	track(action, label) {
		yalwa.basics.ga.event({
			category: `dol_stream_toastr`,
			action: action,
			label: label
		});
	}
}